module.exports = __webpack_public_path__ + "static/media/bg5.012b626c.jpg";